import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/TextUpdatesIllustration.tsx
const TextUpdatesIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "text-updates.svg",
		alt: t("illustration.imageAlt.textUpdates")
	});
};

//#endregion
export { TextUpdatesIllustration };